export default __webpack_public_path__ + "static/media/clicktoloseminus.a91c381d.md";